export default function BrevetScreenInfoDialogTexts() {
    // Used in

    // BUILD
    return (
        <div className={"flex flex-col justify-start items-start"}>
            <span className={"font-bold text-[20px] text-white -mt-[6px]"}>
               {"Cette année le brevet évolue\u00A0!"}
            </span>
            <span className={"font-normal text-[14px] text-greyLight9 mt-[12px]"}>
                {"Il est composé de deux parties\u00A0:"}
            </span>
            <ul className={"list-disc pl-[16px] mt-[8px] font-normal text-[14px] text-greyLight9 space-y-[4px]"}>
                <li>
                    <span>
                        {"Une partie automatisme (6 points) sans calculatrice qui va te tester sur les savoir-faire fondamentaux."}
                    </span>
                </li>
                <li>
                    <span>
                        {"Une partie consacrée au raisonnement (14 points) axée sur la résolution de problèmes plus concrets."}
                    </span>
                </li>
            </ul>
            {/*<span className={"font-normal text-[14px] text-greyLight9 mt-[8px]"}>*/}
            {/*    {"Je t'explique tout en vidéo\u00A0!"}*/}
            {/*</span>*/}
        </div>
    );
}